import { useState } from "react";
import Api, { errorToast } from "utils/api/Api";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { signoutAction } from "./auth/ducks/auth";


export const UserLeave = () => {
  const [isAgree, setIsAgree] = useState(false);
  const [password, setPassword] = useState("");
  const [isResign, setIsResign] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    checkResign.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkResign = useMutation({
    mutationFn: () => Api.get(`/api/user/leave-check`),
    onSuccess: (res) => setIsResign(res.data),
    onError: errorToast,
  });

  const resignMutate = useMutation({
    mutationFn: (data) => Api.post(`/api/user/leave`, data),
    onSuccess: () => {
      toast.success("회원탈퇴신청이 완료되었습니다.");
      dispatch(signoutAction());
    },
    onError: errorToast,
  });

  const cancelResignMutate = useMutation({
    mutationFn: () => Api.get(`/api/user/leave-cancel`),
    onSuccess: () => {
      toast.success("회원탈퇴신청이 취소 되었습니다.");
      setIsResign(false);
    },
    onError: errorToast,
  });


  const resign = () => {
    if (!isAgree) return toast.error("안내 사항에 동의해주세요.");
    if (password.length <= 0) return toast.error("비밀번호를 작성해주세요.");
    if (!window.confirm("회원탈퇴 후 해당 계정은 복구가 불가능합니다. 정말 회원탈퇴신청을 하시겠습니까?")) return;
    resignMutate.mutate({ password });
  };

  if (isResign === null) return;

  if (isResign === true) return (
    <div className="resign-page">
      <h4 className="title">회원탈퇴 취소</h4>
      <div className="resign-content">
        <div className="guide-box">
          <strong>회원탈퇴 신청이 있습니다.</strong>
          <p className="description">회원탈퇴 취소 버튼을누르면 회원탈퇴가 취소됩니다. 취소하시겠습니까?</p>
        </div>
        <div className="button-wrapper">
          <button className="btn _blue" onClick={() => cancelResignMutate.mutate()}>신청취소</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="resign-page">
      <h4 className="title">회원탈퇴</h4>
      <div className="resign-content">
        <div className="guide-box">

          <strong>회원탈퇴신청 7일 후 회원탈퇴 되며 계정 정보는 자동파기됩니다.</strong>
          <p className="description">탈퇴한 계정의 회원 정보는 모두 파기되며 파기된 데이터는 복구가 불가능합니다.</p>

          <strong>회원탈퇴 후에도 내가 작성한 독서 활동은 그대로 남아있습니다.</strong>
          <p className="description">삭제하고 싶은 독서 활동이 있다면 반드시 회원탈퇴 전 삭제하시길 바랍니다.</p>

          <div className="input_check">
            <input type="checkbox" id="agree" onChange={() => setIsAgree(!isAgree)} />
            <label htmlFor="agree">안내 사항을 모두 확인하였으며, 이에 동의합니다.</label>
          </div>
        </div>

        <p className="description">회원탈퇴를 진행하기 위해 해당 계정의 비밀번호를 입력해주세요.</p>
        <div className="input-password">
          <label htmlFor="password">비밀번호</label>
          <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div className="button-wrapper">
          <button className="btn _blue" onClick={resign}>회원탈퇴신청</button>
        </div>

      </div>

    </div>
  );
};